export default __webpack_public_path__ + "b81c396c34ace62b962fb3e3befed9d3.wav";